import React, { useState, useEffect } from 'react';
import SharedDialog from '../../global/Modal/Modal';
import { syncCookieConsentWithCognito } from '../../utils/cookieConsentSync';
import { needsPolicyAcceptance, setAcceptedPolicyVersion } from '../../utils/policyVersionUtils';

const CURRENT_POLICY_VERSION = '1.1';

export const PolicyUpdateModal = ({ isAuthenticated, userId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
    const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !userId) {
      setIsOpen(false);
      return;
    }

    if (needsPolicyAcceptance(userId, CURRENT_POLICY_VERSION)) {
      const timer = setTimeout(() => {
        setShouldShow(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, userId]);


  useEffect(() => {
    if (!shouldShow) {
      setIsOpen(false);
      return;
    }

    if (isAccepting) {
      return;
    }

    const checkTrialModal = () => {
      if (isAccepting) return;
      
      const trialModalExists = document.querySelector('.trial-modal-overlay');
      if (!trialModalExists) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };

    checkTrialModal();

    const observer = new MutationObserver(checkTrialModal);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const interval = setInterval(checkTrialModal, 500);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, [shouldShow, isAccepting]);


  const handleAcceptPolicies = () => {
    setIsAccepting(true);
    setShouldShow(false);

    const completeAcceptance = () => {
      if (typeof window.CookieConsent !== 'undefined') {
        const preferences = {
          categories: window.CookieConsent.config.categories,
          version: CURRENT_POLICY_VERSION,
        };
        syncCookieConsentWithCognito(userId, preferences);
      }

      setAcceptedPolicyVersion(userId, CURRENT_POLICY_VERSION);

      setIsAccepting(false);
      setIsOpen(false);
    };

    const handleDocumentClick = event => {
      const target = event.target;

      if (
        target.classList.contains('consent-give') ||
        target.classList.contains('ccm__footer') ||
        target.textContent?.includes('Accept all cookies') ||
        target.textContent?.includes('Save current settings') ||
        target.textContent?.includes('Aceptar todas las cookies') ||
        target.textContent?.includes('Guardar configuración actual')
      ) {
        setTimeout(() => {
          document.removeEventListener('click', handleDocumentClick);
          completeAcceptance();
        }, 500);
      }
    };

    document.addEventListener('click', handleDocumentClick);

    const modalElement = document.getElementById('cconsent-modal');
    if (modalElement) {
      modalElement.classList.add('ccm--visible');
    }

    setTimeout(() => {
      document.removeEventListener('click', handleDocumentClick);
      setIsAccepting(false);
    }, 60000);
  };

  const handleClose = () => {
    // Handle close
  };

  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Privacy Policy and Cookies updated"
      size="lg"
      className="policy-update-modal"
      hasCancelBtn={false}
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          We have updated our privacy and cookie policies to improve transparency and comply with current
          regulations.
        </p>

        <p className="text-gray-700">
          To continue using DISGENET, you must review and accept the new policies.
        </p>

        <p className="text-sm text-gray-600">
          By clicking “Review and Accept Policies,” the cookie settings panel will open, where you can review
          and configure your preferences.
        </p>

        <div className="flex justify-end gap-3 pt-4">
          <button
            onClick={handleAcceptPolicies}
            disabled={isAccepting}
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
          >
            {isAccepting ? 'Loading...' : 'Review and Accept Policies'}
          </button>
        </div>
      </div>
    </SharedDialog>
  );
};

export default PolicyUpdateModal;
